export enum OneDriveOverWriteEnum {
    rename = 1,
    replace = 2,
    notSelected = 3
}